import { useQuery } from '@tanstack/react-query';

import { getRecipesByPagination } from '../../../../api/recipe';
import { RecipeApi } from '../../../../api/recipe/recipe.api';
import { CurationType } from '../../../../type/recipe';
import { useGetThisWeekVegetables } from '../../../../utils/hook/recipe';
import { useHistoryMethod } from '../../../../utils/hook/useHistoryMethod';
import LoadingPage from '../../../LoadingPage';

import LatestRecipeCard from './LatestRecipeCard';

const LatestRecipeCuration = () => {
  const history = useHistoryMethod();

  const { thisWeekVegetables } = useGetThisWeekVegetables();
  const { data } = useQuery({
    queryKey: RecipeApi.queryKeys.latestRecipes(),
    queryFn: () => getRecipesByPagination('1', '4', 'createdAt'),
  });

  if (!data) {
    return <LoadingPage />;
  }

  const { items: recipes, totalCount } = data;

  return (
    <div className="flex flex-col gap-24px px-16px">
      <p className="flex items-center gap-4px text-22px font-bold">
        최신 레시피{' '}
        <span className="text-brand-1">{totalCount.toLocaleString()}</span>
      </p>
      <div className="grid grid-cols-2 gap-10px sm:grid-cols-4">
        {recipes.map((recipe) => (
          <LatestRecipeCard
            key={recipe.id}
            recipe={recipe}
            thisWeekVegetables={thisWeekVegetables}
          />
        ))}
      </div>
      <button
        onClick={() =>
          history.push(`/recipes/curation?type=${CurationType.LATEST}`)
        }
        className="h-48px w-full rounded-10px border border-gray-300 text-16px font-semibold text-gray-600"
        type="button"
      >
        모두 보기
      </button>
    </div>
  );
};

export default LatestRecipeCuration;
